"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error.tsx]", error);
  }, [error]);

  // Substitui o layout raiz: sem tokens do app, então carrega o mínimo inline —
  // pilha de fontes Apple, fundo agrupado e escuro automático (prefers-color-scheme).
  return (
    <html lang="pt-BR">
      <head>
        <style>{`
          :root { color-scheme: light dark; --bg:#f2f2f7; --card:#fff; --fg:#000; --fg2:rgba(60,60,67,.78); --tint:#ff6e32; --on-tint:#1a0900; }
          @media (prefers-color-scheme: dark) { :root { --bg:#000; --card:#1c1c1e; --fg:#fff; --fg2:rgba(235,235,245,.62); } }
          body { margin:0; min-height:100dvh; display:flex; align-items:center; justify-content:center; padding:2rem; background:var(--bg); color:var(--fg);
                 font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","SF Pro Display","Helvetica Neue",system-ui,sans-serif; -webkit-font-smoothing:antialiased; }
          .box { max-width:28rem; text-align:center; background:var(--card); border-radius:1.625rem; padding:2rem; }
          h2 { font-size:1.375rem; line-height:1.75rem; font-weight:600; margin:0; }
          p { font-size:.9375rem; line-height:1.25rem; color:var(--fg2); margin:.5rem 0 0; }
          button { margin-top:1.25rem; min-height:44px; padding:0 1.5rem; background:var(--tint); color:var(--on-tint); border:0; border-radius:9999px; font:inherit; font-weight:500; cursor:pointer; }
          button:focus-visible { outline:2px solid var(--fg); outline-offset:2px; }
        `}</style>
      </head>
      <body>
        <div className="box" role="alert">
          <h2>Erro crítico</h2>
          <p>{error.message || "O app não conseguiu carregar."}</p>
          {error.digest && (
            <p style={{ fontSize: "0.75rem", fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>
              ID: {error.digest}
            </p>
          )}
          <button type="button" onClick={() => reset()}>
            Tentar novamente
          </button>
        </div>
      </body>
    </html>
  );
}
